import { render, staticRenderFns } from "./ProductsPage.vue?vue&type=template&id=0e9c327f&scoped=true&"
import script from "./ProductsPage.vue?vue&type=script&lang=js&"
export * from "./ProductsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsPage.vue?vue&type=style&index=0&id=0e9c327f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9c327f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VCol,VProgressCircular,VRow,VTextField})
